import { useStaticRandom } from './useStaticRandom'

// Like React’s `useId()`, but draws its source of randomness from the commit hash
// (via `useStaticRandom()`) rather than from the React tree (like `useId()`).
// This makes it more reliable in our codebase, as we’re still not great at ensuring
// that the server and the client render 100% the same tree.
export default function useStaticRandomId() {
  const staticRandom = useStaticRandom()
  return `static-random-id-${staticRandom().toFixed(10).slice(2)}`
}
